import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * LiveDot — 8px Volt circle that pulses with the volt-glow halo.
 * Mirrors `.live-dot` from design/app-tokens.css and uses the
 * `animate-volt-pulse` keyframe registered in tailwind.config.ts.
 */
export type LiveDotProps = HTMLAttributes<HTMLSpanElement>;

export const LiveDot = forwardRef<HTMLSpanElement, LiveDotProps>(
  ({ className, ...props }, ref) => {
    return (
      <span
        ref={ref}
        aria-hidden="true"
        className={cn(
          'inline-block w-2 h-2 rounded-full bg-volt animate-volt-pulse',
          className,
        )}
        {...props}
      />
    );
  },
);
LiveDot.displayName = 'LiveDot';
